import { Component, Input } from '@angular/core';
import { NgxPopupComponent } from '../ngx-popups/ngx-popups/ngx-popups';

/**
 * Keyboard shortcuts modal for the legacy Data Categorization page
 * (`SpreadingComponent`). The redesigned page (`SpreadingV2Component`) uses
 * `KeyboardShortcutsComponent` instead.
 *
 * @TechDebt: delete this component along with the legacy page once the
 * `data-categorization-redesign` flag is fully rolled out.
 */
@Component({
    selector: 'app-keyboard-shortcuts-legacy',
    templateUrl: './keyboard-shortcuts-legacy.component.html',
    styleUrls: ['./keyboard-shortcuts-legacy.component.scss'],
    standalone: false
})
export class KeyboardShortcutsLegacyComponent {
  @Input() popup: NgxPopupComponent;
}
